var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburguerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12V10H18V12H0ZM0 7V5H18V7H0ZM0 2V0H18V2H0Z",
    fill: "#01172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburguerIcon);
export default __webpack_public_path__ + "static/media/hamburguer-icon.7bc9f20fee5ffd00241e4458b8b7fb4b.svg";
export { ForwardRef as ReactComponent };